import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "fill-current"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.613 10a.374.374 0 0 0-.06-.113l-.08-.1a.667.667 0 0 0-1.126.34.818.818 0 0 0 0 .126.587.587 0 0 0 .053.26.667.667 0 0 0 1.087.214.667.667 0 0 0 .14-.214.667.667 0 0 0 .053-.26.818.818 0 0 0 0-.126.468.468 0 0 0-.067-.127ZM8 4.907a.667.667 0 0 0-.667.666v2a.667.667 0 1 0 1.334 0v-2A.667.667 0 0 0 8 4.907Zm5.087-2.474a.666.666 0 0 0-.56-.133 5.333 5.333 0 0 1-4.147-.847.667.667 0 0 0-.76 0 5.333 5.333 0 0 1-4.147.847.667.667 0 0 0-.806.653V7.92a6 6 0 0 0 2.513 4.887l2.433 1.733a.667.667 0 0 0 .774 0l2.433-1.733a6 6 0 0 0 2.513-4.887V2.953a.667.667 0 0 0-.246-.52ZM12 7.92a4.666 4.666 0 0 1-1.953 3.8L8 13.18l-2.047-1.46A4.666 4.666 0 0 1 4 7.92v-4.2a6.667 6.667 0 0 0 4-.927 6.667 6.667 0 0 0 4 .927v4.2Z"
    }, null, -1)
  ])))
}
export default { render: render }